import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import AppShell from '../components/AppShell';
import CRMStats from '../components/crm/CRMStats';
import CustomerList from '../components/crm/CustomerList';
import CustomerDetail from '../components/crm/CustomerDetail';
import SMSPanel from '../components/crm/SMSPanel';
import ExportPanel from '../components/crm/ExportPanel';

export default function CRMPage() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [panel, setPanel] = useState(null);

  useEffect(() => {
    api.get('/customers/').then(r => setCustomers(r.data)).finally(() => setLoading(false));
    api.get('/stores/').then(r => setStores(r.data)).catch(() => {});
  }, []);

  function handleCreated(customer) {
    setCustomers(prev => [customer, ...prev]);
    setSelected(customer);
  }

  function handleUpdated(customer) {
    setSelected(customer);
    setCustomers(prev => prev.map(c => c.id === customer.id ? customer : c));
  }

  function handleDeleted(customerId) {
    setCustomers(prev => prev.filter(c => c.id !== customerId));
    setSelected(null);
  }

  function togglePanel(name) {
    setPanel(prev => prev === name ? null : name);
  }

  return (
    <AppShell
      title="CRM — База клієнтів"
      onBack={() => navigate('/dashboard')}
      wide
      right={
        <>
          <button className={`btn btn-sm ${panel === 'sms' ? 'btn-primary' : 'btn-soft'}`}
            onClick={() => togglePanel('sms')}>📱 SMS</button>
          <button className={`btn btn-sm ${panel === 'export' ? 'btn-primary' : 'btn-soft'}`}
            onClick={() => togglePanel('export')}>⬇️ Експорт</button>
        </>
      }
    >
      <CRMStats customers={customers} />
      {panel === 'sms' && <SMSPanel stores={stores} />}
      {panel === 'export' && <ExportPanel stores={stores} />}

      <div className="crm-layout">
        <CustomerList
          customers={customers}
          loading={loading}
          selected={selected}
          onSelect={setSelected}
          onCreated={handleCreated}
        />
        <CustomerDetail
          customer={selected}
          onUpdated={handleUpdated}
          onDeleted={handleDeleted}
        />
      </div>
    </AppShell>
  );
}
